export const tooltips = {
	methods: {
		tooltips() {
			const tooltips = document.querySelectorAll('[data-tooltip]'),
				self = this;

			tooltips.forEach(tooltip => {
				tooltip.addEventListener('click', function() {
					self.$store.commit('popupOpen', true);
					self.$store.commit('popupContent', {
						heading: tooltip.dataset.tooltipTitle,
						body: tooltip.dataset.tooltipText
					});
				});
			});
		}
	}
};